import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { USER_LOCK_STATE } from 'src/app/core/helpers/global/global.constant';
import { User } from 'src/app/core/interfaces/api/user.interface';
import { ModalWithAction } from 'src/app/core/interfaces/ui/bootstrap-modal.interface';
import { UserService } from 'src/app/core/services/api/user.service';
import { BootstrapModalService } from 'src/app/core/services/ui/bootstrap-modal.service';
import { FilterService } from 'src/app/core/services/ui/filter.service';

@Component({
  selector: 'block-user',
  templateUrl: './block-user.component.html',
})
export class BlockUserComponent implements OnInit, OnDestroy {
  private userId: string | undefined;
  private unsubscribe$: Subject<boolean> = new Subject<boolean>();
  public USER_LOCK_STATE = USER_LOCK_STATE;
  public targetState: number = USER_LOCK_STATE.LOCKED;
  public reason: string = '';

  constructor(
    private _bsModalService: BootstrapModalService<ModalWithAction<User>>,
    private _filterService: FilterService<object>,
    private _userService: UserService
  ) {}

  ngOnInit(): void {
    this.subscribeToModalData();
  }

  private subscribeToModalData(): void {
    this._bsModalService
      .getDataIssued()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ({ selectedRow, targetState }) => {
          this.userId = selectedRow?._id;
          if (targetState !== undefined) {
            this.targetState = targetState;
          }
        },
        error: () => this.closeModal(),
      });
  }

  public get isBlocking(): boolean {
    return this.targetState === USER_LOCK_STATE.LOCKED;
  }

  public get isReasonValid(): boolean {
    return this.reason.trim().length > 0;
  }

  public blockUser(): void {
    if (!this.userId || !this.isReasonValid) {
      return;
    }
    const body = {
      userId: this.userId,
      isLocked: this.isBlocking,
      reason: this.reason.trim(),
    };
    this._userService.setUserLockStatus(body).subscribe(() => this.afterSubmitForm());
  }

  public closeModal(): void {
    this._bsModalService.closeModal();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  private afterSubmitForm(): void {
    this._filterService.updateFilterData({});
    this.closeModal();
  }
}
